// extracted by mini-css-extract-plugin
module.exports = {"audits":"admin-portal__DrugActiveIngredientsAudits__audits","rightRow":"admin-portal__DrugActiveIngredientsAudits__rightRow"};